import { render, staticRenderFns } from "./MassImageUpload.vue?vue&type=template&id=1dbce198&scoped=true&"
import script from "./MassImageUpload.vue?vue&type=script&lang=ts&"
export * from "./MassImageUpload.vue?vue&type=script&lang=ts&"
import style0 from "./MassImageUpload.vue?vue&type=style&index=0&id=1dbce198&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dbce198",
  null
  
)

export default component.exports